import React, { ReactElement } from 'react';

import { withPrefix } from 'gatsby';
import { styled } from 'styled-components';

export const TagWrapper = styled.a<{
  $color?: string;
  $onClick?: boolean;
  $noHover?: boolean;
  $inverse?: boolean;
  $borderColor?: string;
  $textHoverColor?: string;
}>`
  border-radius: 5rem;
  background-color: transparent;
  ${(props) => `
    border: solid 1px ${props.$borderColor ? props.$borderColor : (props.$color ?? props.theme.colors.primaryBlack2)};
    color: ${props.$color ?? props.theme.colors.primaryBlack2};
    ${props.$onClick && 'cursor: pointer'};

    ${
      props.$inverse &&
      `
      background-color: ${props.$color ?? props.theme.colors.primaryBlack2};
      color: ${props.theme.colors.white};
    `
    };
  `}
  padding: 0.25rem 0.75rem;
  text-transform: uppercase;
  font-size: 0.75rem;
  font-weight: 600;
  text-decoration: none;
  transition: background-color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);

  ${(props) =>
    !props.$noHover &&
    `
    &:hover {
      color: ${props.theme.colors.white};
      background-color: ${props.$color ?? props.theme.colors.primaryBlack2};

      ${
        props.$inverse &&
        `
        border: solid 1px ${props.$borderColor ? props.$borderColor : (props.$color ?? props.theme.colors.primaryBlack2)};
        color: ${props.$color ?? props.theme.colors.primaryBlack2};
        background-color: ${props.theme.colors.white};
      `
      };
    }
  `}

  ${(props) =>
    props.$textHoverColor &&
    `
    &:hover {
      color: ${props.$textHoverColor} !important;
    }`}
`;

export interface TagProps {
  label: ReactElement | string;
  color?: string;
  url?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => void;
  noHover?: boolean;
  inverse?: boolean;
  borderColor?: string;
  textHoverColor?: string;
}

const Tag = (props: TagProps) => {
  const { label, color, url, onClick, noHover, inverse, borderColor, textHoverColor } = props;
  const isLink = !!url;

  return (
    <TagWrapper
      as={isLink ? 'a' : 'button'}
      $color={color}
      href={withPrefix(url ?? '')}
      onClick={onClick}
      $onClick={!!onClick}
      $noHover={noHover}
      $inverse={inverse}
      $borderColor={borderColor}
      $textHoverColor={textHoverColor}
    >
      {label}
    </TagWrapper>
  );
};

export default Tag;
